module.exports = __webpack_public_path__ + "static/media/zhizhen.9fcbeb23.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/zhizhen.png
// module id = 191
// module chunks = 0 1